import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Contact } from "@/components/site/Contact";

export default function ContactPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <div className="grain relative min-h-screen">
      <Helmet>
        <title>Contact — GMP Développement</title>
        <meta
          name="description"
          content="Contactez GMP Développement pour vos chevalets avis Google, menus digitaux et la gestion de votre fiche Google. Réponse sous 24h."
        />
        <link rel="canonical" href={`${origin}/contact`} />
        <meta property="og:title" content="Contact — GMP Développement" />
        <meta property="og:type" content="website" />
      </Helmet>
      <Navbar />
      <main className="pt-16">
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
